import React, { Component } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import { Button, Image } from "react-bootstrap";

import classnames from "classnames";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import { InputBoxComponent } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
// import { BankAndOtherDetailsHome } from "./BankAndOtherDetailsHome";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import {
  InputCharNumFunc,
  InputCharacterCheck,
} from "../../../../function/InputCharNumCheckFunc";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
// import BankDetailsUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/BankDetailsUploadComponent";
import SimpleReactLightbox from "simple-react-lightbox";
// import { TermsandConditionPopup } from "../../reusableOnboardingPopupComponent/termsAndConditions/TermsandConditionPopup";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { RestaurantKYCDetailsValidationTwo } from "../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantKYCDetailsValidation";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";
import Alert from "react-s-alert";
import Media from "react-media";
import VendorBankKycDetails from "./VendorBankKycDetails";

export class VendorBankDetailsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      open: false,
      successPopupOpen: false,
      checkboxAcceptTerms: false,
      selectNextScreen: false,
      bankName: "",
      currentSavingAccount: "",
      accountNumber: "",
      branchName: "",
      gstNumber: "",
      ifscCode: "",
      fssaiCode: "",
      panCard: "",
      kyc_photo: [],
      bank_Informaion: [],
      hasSetBankProps: false,
      errors: [],
    };
    this.onDrop = this.onDrop.bind(this);
    this.onDropBank = this.onDropBank.bind(this);
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
    if (
      this.props.onboarding._id
      //  &&
      // !isEmpty(this.props.onboarding.bank_name)
    ) {
      // if (
      //   !isEmpty(this.props.onboarding.bank_name) &&
      //   !isEmpty(this.props.onboarding.selectHomeScreen) &&
      //   !this.state.hasSetBankProps
      // ) {
      this.setState({
        bankName: !isEmpty(this.props.onboarding.bank_name)
          ? this.props.onboarding.bank_name
          : "",
        currentSavingAccount: !isEmpty(
          this.props.onboarding.current_saving_account
        )
          ? this.props.onboarding.current_saving_account
          : "",
        accountNumber: !isEmpty(this.props.onboarding.account_number)
          ? this.props.onboarding.account_number
          : "",
        branchName: !isEmpty(this.props.onboarding.branch_name)
          ? this.props.onboarding.branch_name
          : "",
        gstNumber: !isEmpty(this.props.onboarding.gst_number)
          ? this.props.onboarding.gst_number
          : "",
        ifscCode: !isEmpty(this.props.onboarding.ifsc_code)
          ? this.props.onboarding.ifsc_code
          : "",
        fssaiCode: !isEmpty(this.props.onboarding.fssai_code)
          ? this.props.onboarding.fssai_code
          : "",
        panCard: !isEmpty(this.props.onboarding.pan_card)
          ? this.props.onboarding.pan_card
          : "",
        kyc_photo: !isEmpty(this.props.onboarding.kyc_photo)
          ? this.props.onboarding.kyc_photo
          : [],
        bank_Informaion: !isEmpty(this.props.onboarding.bank_informaion)
          ? this.props.onboarding.bank_informaion
          : [],
        hasSetBankProps: true,
      });
      // }
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    if (
      nextProps.onboarding._id
      //  && !isEmpty(nextProps.onboarding.bank_name)
    ) {
      // if (
      //   !isEmpty(nextProps.onboarding.bank_name) &&
      //   !isEmpty(nextProps.onboarding.selectHomeScreen) &&
      //   !nextState.hasSetBankProps
      // ) {
      return {
        bankName: !isEmpty(nextProps.onboarding.bank_name)
          ? nextProps.onboarding.bank_name
          : "",
        currentSavingAccount: !isEmpty(
          nextProps.onboarding.current_saving_account
        )
          ? nextProps.onboarding.current_saving_account
          : "",
        accountNumber: !isEmpty(nextProps.onboarding.account_number)
          ? nextProps.onboarding.account_number
          : "",
        branchName: !isEmpty(nextProps.onboarding.branch_name)
          ? nextProps.onboarding.branch_name
          : "",
        gstNumber: !isEmpty(nextProps.onboarding.gst_number)
          ? nextProps.onboarding.gst_number
          : "",
        ifscCode: !isEmpty(nextProps.onboarding.ifsc_code)
          ? nextProps.onboarding.ifsc_code
          : "",
        fssaiCode: !isEmpty(nextProps.onboarding.fssai_code)
          ? nextProps.onboarding.fssai_code
          : "",
        panCard: !isEmpty(nextProps.onboarding.pan_card)
          ? nextProps.onboarding.pan_card
          : "",
        kyc_photo: !isEmpty(nextProps.onboarding.kyc_photo)
          ? nextProps.onboarding.kyc_photo
          : [],
        bank_Informaion: !isEmpty(nextProps.onboarding.bank_informaion)
          ? nextProps.onboarding.bank_informaion
          : [],
        hasSetBankProps: true,
      };
      // }
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    return null;
  }

  backSecondScreenClickChange = () => {
    console.log("hiiiii");
    this.props.history.push("/editprofile");
  };

  buttonNextClickChange = (formData) => {
    const newformData = formData;
    newformData.vendor_id = this.props.onboarding.vendor_id;
    newformData.id = this.props.onboarding._id;
    newformData.page_completed_till = 21;
    if (this.props.onboarding) {
      this.props.create_and_update_restaurant(
        formData,
        this.backSecondScreenClickChange
      );
      this.setState({
        selectNextScreen: true,
        actionButton: false,
      });
    }
    // e.preventDefault();
    // const { errors, isValid } = RestaurantKYCDetailsValidationTwo(this.state);
    // if (!isValid) {
    //   this.setState({
    //     errors: errors,
    //   });
    // } else {
    //   const formData = {
    //     vendor_id: this.props.onboarding.vendor_id,
    //     id: this.props.onboarding._id,
    //     gst_number: this.state.gstNumber,
    //     ifsc_code: this.state.ifscCode,
    //     fssai_code: this.state.fssaiCode,
    //     pan_card: this.state.panCard,
    //   };
    //   this.props.create_and_update_restaurant(formData);
    //   this.setState({
    //     selectNextScreen: true,
    //     actionButton: false,
    //   });
    // }
  };

  NextButtonClickChange = (e) => {
    e.preventDefault();
    this.setState({
      selectNextScreen: true,
    });
  };

  buttonNextBackClickChange = (e) => {
    e.preventDefault();
    this.setState({
      selectNextScreen: false,
    });
  };

  onPoupModelOpen = (e) => {
    this.setState({
      open: true,
    });
  };

  onClosedModel = (e) => {
    this.setState({
      open: false,
    });
  };

  openSuccessModalClick = () => {
    this.setState({
      successPopupOpen: true,
    });
  };

  onClosedModelSuccessModel = () => {
    this.setState({
      open: false,
      successPopupOpen: false,
    });
  };

  handleCheckbox = (e) => {
    this.setState({
      currentSavingAccount: e.currentTarget.value,
      actionButton: true,
    });
  };

  handleCheckboxRemove = (e) => {
    this.setState({
      currentSavingAccount: "",
      actionButton: true,
    });
  };

  /*********************************
   * @DESC Multiple Image Upload
   ********************************/
  onDrop(picture) {
    this.setState({
      kyc_photo: picture,
      actionButton: true,
    });
  }

  onDropBank(picture) {
    this.setState({
      bank_Informaion: picture,
      actionButton: true,
    });
  }

  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  kycUploadMultipleFiles = (e) => {
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      let allPicures = this.state.kyc_photo;
      allPicures.some((phone) => {
        if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
          flag = true;
        }
      });
      if (!flag) {
        data.append("files", e.target.files[i]);
      }
    }
    if (!flag) {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        .then((res) => {
          let oldData = this.state.kyc_photo;
          let newData = res.data;
          let mergedData = oldData.concat(newData);
          this.setState({
            kyc_photo: mergedData,
            // kycImageLoader: false,
            actionButton: true,
          });
          Alert.success(`<h4>Bank Details Image Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ kycImageLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // this.setState({ kycImageLoader: false });
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  kycDocMultipleRemove = (indexId) => (e) => {
    let allKycDetails = this.state.kyc_photo;
    let allKycDetailsObj = allKycDetails.find(
      (images, index) => index === indexId
    );
    if (allKycDetailsObj === 0 || allKycDetailsObj) {
      allKycDetails.splice(allKycDetails.indexOf(allKycDetailsObj), 1);
      this.setState({ allKycDetails: allKycDetails, actionButton: true });
    }
  };

  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  bankUploadMultipleFiles = (e) => {
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      let allPicures = this.state.bank_Informaion;
      allPicures.some((phone) => {
        if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
          flag = true;
        }
      });
      if (!flag) {
        data.append("files", e.target.files[i]);
      }
    }
    if (!flag) {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        .then((res) => {
          let oldData = this.state.bank_Informaion;
          let newData = res.data;
          let mergedData = oldData.concat(newData);
          this.setState({
            bank_Informaion: mergedData,
            // bankImageLoader: false,
            actionButton: true,
          });
          Alert.success(`<h4>Bank Details Image Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ bankImageLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // this.setState({ bankImageLoader: false });
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  bankDocMultipleRemove = (indexId) => (e) => {
    let allBankDetails = this.state.bank_Informaion;
    let allBankDetailsObj = allBankDetails.find(
      (images, index) => index === indexId
    );
    if (allBankDetailsObj === 0 || allBankDetailsObj) {
      allBankDetails.splice(allBankDetails.indexOf(allBankDetailsObj), 1);
      this.setState({ allBankDetails: allBankDetails, actionButton: true });
    }
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/editprofile",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = RestaurantKYCDetailsValidationTwo(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      if (this.props.onboarding._id && this.props.auth.user.VendorUser._id) {
        const formData = {
          vendor_id: this.props.onboarding.vendor_id,
          id: this.props.onboarding._id,
          bank_name: this.state.bankName,
          current_saving_account: this.state.currentSavingAccount,
          account_number: this.state.accountNumber,
          branch_name: this.state.branchName,
          gst_number: this.state.gstNumber,
          ifsc_code: this.state.ifscCode,
          fssai_code: this.state.fssaiCode,
          pan_card: this.state.panCard,
          kyc_photo: this.state.kyc_photo,
          bank_informaion: this.state.bank_Informaion,
        };
        this.props.create_and_update_restaurant(formData);
        this.setState({
          editButton: false,
          actionButton: false,
        });
      }
    }

    // this.onPoupModelOpen();
  };

  renderFirstScreen = () => {
    const {
      editButton,
      errors,
      bankName,
      currentSavingAccount,
      accountNumber,
      branchName,
      ifscCode,
      // bank_Informaion,
      actionButton,
    } = this.state;
    return (
      <React.Fragment>
        <div className="bank_and_other_details_onboarding_main">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 p-0">
            <InputBoxComponent
              displayLabel={true}
              controlId="bankName"
              // labelText="Enter banking information about your restaurant."
              labelText="Bank Name"
              placeHolder="eg. ABC Bank*"
              maxLength="35"
              name="bankName"
              inputType="text"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              onKeyDown={InputCharacterCheck}
              value={this.state.bankName}
              disabled={editButton === false ? true : false}
              required="required"
              error={errors.bankName}
              inputClassName={classnames("input-component-inputfield", {
                invalid: errors.bankName,
              })}
            />
            <div className="checkbox-main-div">
              <h4 className="col-12 p-0">Account Type?</h4>
              <div className="checkbox-bank-account">
                <div className="checkbox-bank-account-one">
                  <h5>Current Account</h5>
                  <Form.Check
                    type="radio"
                    aria-label="radio 1"
                    className="checkbox-bank-account-radio"
                    value="currentAccount"
                    checked={
                      this.state.currentSavingAccount === "currentAccount"
                    }
                    onChange={this.handleCheckbox}
                    onClick={this.handleCheckboxRemove}
                    disabled={editButton === false ? true : false}
                  />
                </div>
                <div className="checkbox-bank-account-one">
                  <h5>Savings Account</h5>
                  <Form.Check
                    type="radio"
                    aria-label="radio 2"
                    className="checkbox-bank-account-radio"
                    value="savingAccount"
                    checked={
                      this.state.currentSavingAccount === "savingAccount"
                    }
                    onChange={this.handleCheckbox}
                    onClick={this.handleCheckboxRemove}
                    disabled={editButton === false ? true : false}
                  />
                </div>
              </div>
            </div>
            <InputBoxComponent
              displayLabel={true}
              controlId="branchName"
              labelText="Branch Name"
              placeHolder="eg. ABC Branch*"
              maxLength="35"
              name="branchName"
              inputType="text"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              onKeyDown={InputCharacterCheck}
              value={this.state.branchName}
              disabled={editButton === false ? true : false}
              required="required"
              error={errors.branchName}
              inputClassName={classnames("input-component-inputfield", {
                invalid: errors.branchName,
              })}
            />
            <InputBoxComponent
              displayLabel={true}
              controlId="accountNumber"
              labelText="Account Number "
              showLabelSmall={true}
              showLabelSmallText="(11 Digits to Max 16 digits)"
              maxLength="16"
              placeHolder="eg. 1234567890123456*"
              name="accountNumber"
              inputType="number"
              onKeyDown={InputNumberFunc}
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              value={this.state.accountNumber}
              disabled={editButton === false ? true : false}
              required="required"
              error={
                this.state.accountNumber.length > 0 &&
                this.state.accountNumber.length <= 10
                  ? "Enter Valid Account Number"
                  : null || this.state.accountNumber === ""
                  ? errors.accountNumber
                  : null
              }
              inputClassName={classnames("input-component-inputfield", {
                invalid: errors.accountNumber,
              })}
            />
            <InputBoxComponent
              displayLabel={true}
              controlId="ifscCode"
              labelText="IFSC Code"
              showLabelSmall={true}
              showLabelSmallText="(11-Character Code)"
              maxLength="11"
              placeHolder="eg. AAAA0000000*"
              name="ifscCode"
              inputType="text"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              onKeyDown={InputCharNumFunc}
              value={this.state.ifscCode}
              disabled={editButton === false ? true : false}
              required="required"
              error={
                this.state.ifscCode.length > 0 &&
                this.state.ifscCode.length <= 10
                  ? "Enter valid IFSC Code"
                  : null || this.state.ifscCode === ""
                  ? errors.ifscCode
                  : null
              }
              inputClassName={classnames("input-component-inputfield", {
                invalid: errors.ifscCode,
              })}
            />
          </div>
          <div className="col-12 p-0 mb-5">
            {/* <BankDetailsUploadComponent
              title="Upload Documents*"
              smallTitle="(Upload bank related documents)"
              onDrop={this.onDropBank}
              imageExtension={[".jpg", ".gif", ".png", ".jpeg", ".pdf"]}
            /> */}
            <SimpleReactLightbox>
              <MultipleImageUploadComponent
                title="Upload Documents*"
                smallTitle="(Upload bank related documents)"
                onChange={this.bankUploadMultipleFiles}
                stateValue={this.state.bank_Informaion}
                removeImage={this.bankDocMultipleRemove}
                checkCondition={this.state.editButton}
                accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
              />
            </SimpleReactLightbox>
          </div>
          <div className="col-12 p-0 d-flex justify-content-between mb-4">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              buttonType="button"
              onClick={this.buttonNextBackClickChange}
            />
            {editButton === true ? (
              <ReusableOnboardingButton
                buttonTitle={`${
                  actionButton === false ? "Next" : "Save"
                } Button`}
                buttonClass={
                  bankName === "" ||
                  currentSavingAccount === "" ||
                  branchName === "" ||
                  (accountNumber === "" && accountNumber.length <= 11) ||
                  (ifscCode === "" && ifscCode.length <= 11) ||
                  actionButton === false
                    ? // ||
                      // bank_Informaion.length === 0
                      "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                }
                disabled={
                  bankName === "" ||
                  currentSavingAccount === "" ||
                  branchName === "" ||
                  (accountNumber === "" && accountNumber.length <= 11) ||
                  (ifscCode === "" && ifscCode.length <= 11) ||
                  actionButton === false
                    ? // ||
                      // bank_Informaion.length === 0
                      true
                    : false
                }
                buttonText={actionButton === false ? "Next" : "Save"}
                onClick={actionButton === false ? this.onWithOutApiCall : null}
                buttonType={actionButton === false ? "button" : "submit"}
              />
            ) : null}

            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderSecondScreen = () => {
    const {
      editButton,
      errors,
      gstNumber,
      fssaiCode,
      panCard,
      // kyc_photo,
      actionButton,
    } = this.state;
    return (
      <React.Fragment>
        <div className="bank_and_other_details_onboarding_main">
          <div className="col-8 p-0">
            <InputBoxComponent
              displayLabel={true}
              controlId="gstNumber"
              labelText="GST Number"
              showLabelSmall={true}
              showLabelSmallText="(Max 15 Char Code)"
              placeHolder="eg. 22AAAAA0000A1Z5*"
              maxLength="15"
              name="gstNumber"
              inputType="text"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              onKeyDown={InputCharNumFunc}
              value={this.state.gstNumber}
              disabled={editButton === false ? true : false}
              required="required"
              error={
                this.state.gstNumber > 0 && this.state.gstNumber.length <= 14
                  ? "Enter Valid GST Number"
                  : null || this.state.gstNumber === ""
                  ? errors.gstNumber
                  : null
              }
              inputClassName={classnames("input-component-inputfield", {
                invalid: errors.gstNumber,
              })}
            />
            <div className="mt-3">
              <InputBoxComponent
                displayLabel={true}
                controlId="fssaiCode"
                labelText="FSSAI Code"
                showLabelSmall={true}
                showLabelSmallText="(14-character numeric code)"
                maxLength="14"
                placeHolder="eg. 20843454654551*"
                name="fssaiCode"
                inputType="number"
                onChange={this.onChange}
                onFocusOut={this.onFocusOut}
                onKeyDown={InputNumberFunc}
                value={this.state.fssaiCode}
                disabled={editButton === false ? true : false}
                required="required"
                error={
                  fssaiCode.length > 0 && fssaiCode.length <= 13
                    ? "Enter valid FSSAI Code"
                    : null || fssaiCode === ""
                    ? errors.fssaiCode
                    : null
                }
                inputClassName={classnames("input-component-inputfield", {
                  invalid: errors.fssaiCode,
                })}
              />
            </div>
            <div className="mt-3"></div>
            <div className="mt-3"></div>

            <InputBoxComponent
              displayLabel={true}
              controlId="panCard"
              labelText="PAN Number"
              showLabelSmall={true}
              showLabelSmallText="(10-character code)"
              maxLength="10"
              placeHolder="eg. AAAAA1234A*"
              name="panCard"
              inputType="text"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              onKeyDown={InputCharNumFunc}
              value={this.state.panCard}
              disabled={editButton === false ? true : false}
              required="required"
              error={
                panCard.length > 0 && panCard.length <= 9
                  ? "Enter valid Pan Card Number"
                  : null || panCard === ""
                  ? errors.panCard
                  : null
              }
              inputClassName={classnames("input-component-inputfield", {
                invalid: errors.panCard,
              })}
            />
          </div>
          <div className="col-12 p-0">
            {/* <MultipleImageUploadComponent
              title="Upload Documents*"
              smallTitle="(Upload supporting documents for PAN, GST, FSSAI and a
              Cancelled Cheque as applicable)"
              onDrop={this.onDrop}
              imageExtension={[".jpg", ".gif", ".png", ".jpeg", ".pdf"]}
            /> */}
            <SimpleReactLightbox>
              <MultipleImageUploadComponent
                title="Upload Documents*"
                smallTitle="(Upload supporting documents for PAN, GST, FSSAI and a
                Cancelled Cheque as applicable)"
                onChange={this.kycUploadMultipleFiles}
                stateValue={this.state.kyc_photo}
                removeImage={this.kycDocMultipleRemove}
                checkCondition={this.state.editButton}
                accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
              />
            </SimpleReactLightbox>
          </div>
          <div className="col-12 p-0 d-flex justify-content-between mb-4">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingLink
              buttonTitle="Cancel Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Cancel"
              link="/editprofile"
            />
            {editButton === true ? (
              <ReusableOnboardingButton
                buttonTitle="Save Button"
                buttonClass={
                  (gstNumber === "" && gstNumber.length <= 14) ||
                  (fssaiCode === "" && fssaiCode.length <= 13) ||
                  (panCard === "" && panCard.length <= 9) ||
                  actionButton === false
                    ? // ||
                      // kyc_photo.length === 0
                      "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                }
                disabled={
                  (gstNumber === "" && gstNumber.length <= 14) ||
                  (fssaiCode === "" && fssaiCode.length <= 13) ||
                  (panCard === "" && panCard.length <= 9) ||
                  actionButton === false
                    ? // ||
                      // kyc_photo.length === 0
                      true
                    : false
                }
                buttonText="Save"
                onClick={
                  actionButton === false
                    ? this.NextButtonClickChange
                    : this.buttonNextClickChange
                }
                buttonType={actionButton === false ? "button" : "submit"}
                // onClick={this.buttonNextClickChange}
              />
            ) : null}

            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    // if (this.state.loader) {
    //   return (
    //     <React.Fragment>
    //       <AmealioLoader />
    //     </React.Fragment>
    //   );
    // }
    const { selectNextScreen } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/editprofile"
                displayText="Back"
              />
              <div className="col-12 onboarding_process_screen_left bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                {/* <div className="onboarding_process_screen-left-mapinside p-0"> */}
                {/* <div className="onboarding_process_screen-left-mapinside"> */}
                <div className="row restaurant_type_onboarding_main">
                  <div className="col-6">
                    <div>
                      <TopTextReusableComponent
                        headingText="KYC and Bank Info"
                        headingParagraph="Enter banking information for your restaurant"
                        displayEdit={this.state.editButton}
                        onClickEdit={this.editClick}
                      />
                    </div>
                    <VendorBankKycDetails
                      buttonNextClickChangeOne={(formData) =>
                        this.buttonNextClickChange(formData)
                      }
                      actionCall={this.state.actionButton}
                      backSecondScreenClickChange={
                        this.backSecondScreenClickChange
                      }
                      editbutton={this.state.editButton}
                    />
                    {/* {selectNextScreen === false ? (
                      <Form noValidate onSubmit={this.onHandleSubmit}>
                        {this.renderSecondScreen()}
                      </Form>
                    ) : (
                      <Form noValidate onSubmit={this.onHandleSubmit}>
                        {this.renderFirstScreen()}
                      </Form>
                    )} */}
                  </div>
                  {/* <div className="col-2">
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      style={{
                        border: this.state.editButton ? "" : "none !important",
                      }}
                      onClick={this.editClick}
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>
                  </div> */}
                </div>
                {/* </div> */}
                {/* </div> */}
              </div>
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorBankDetailsEdit.propTypes = {
  onboarding: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorBankDetailsEdit));
